import React, { useState } from 'react';
import styled from 'styled-components';
import ExpandingCard from '../components/common/ExpandingCard';
import { reportesCardData } from '../components/common/reportesCardData';

const PageWrapper = styled.div`
  padding: 40px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 32px;
  align-items: start;
`;

const ReportesPage: React.FC = () => {
  const [expandedCardId, setExpandedCardId] = useState<string | null>(null);

  return (
    <PageWrapper>
      {reportesCardData.map((card) => (
        <ExpandingCard
          key={card.id}
          cardInfo={card}
          isExpanded={expandedCardId === card.id}
          onMouseEnter={() => setExpandedCardId(card.id)}
          onMouseLeave={() => setExpandedCardId(null)}
        />
      ))}
    </PageWrapper>
  );
};

export default ReportesPage;
